import {
  IOfferingsListItem,
  TOfferingRtm,
} from 'legacy/lut/features/partner360/jbpSettings/models/offeringsListItem'

// Backend still sends the legacy 'Commercial' RTM for resellers.
const normalizeRtm = (rtm: TOfferingRtm) => (rtm === 'Commercial' ? 'Reseller' : rtm)

export const getRtmOfferings = (offeringsList: IOfferingsListItem[], rtm: string) => [
  ...new Set(
    offeringsList
      .filter((item) => normalizeRtm(item.rtm) === rtm)
      .sort((a, b) => a.orderBy - b.orderBy)
      .map(({ offering }) => offering)
  ),
]
